import { createSlice } from "@reduxjs/toolkit";

interface IInitialState {
  time: string;
  isClearTime: boolean;
}

const initialState: IInitialState = {
  time: "stop",
  isClearTime: false,
};

export const timerSlice = createSlice({
  name: "timer",
  initialState: initialState,
  reducers: {
    getClearTime: (state, action) => {
      state.isClearTime = action.payload;
    },
    getTimeSuccess: (state, action) => {
      const data = action.payload.data;
      const key = action.payload.key || "time";

      return {
        ...state,
        [key]: data
      };
    }
  }
});

export const { getClearTime, getTimeSuccess } = timerSlice.actions;

export default timerSlice.reducer;
